module.exports = __webpack_public_path__ + "img/help-yellow.648f838b.svg";